module.exports = __webpack_public_path__ + "static/20230619_160-8c9690624d91c91f2ca16819db7cc11c.jpg";